import { useAccountStore } from '@/store/use-account-store';
import { COLLATERAL_DECIMALS } from '@/store/use-markets-store';
import { FilledOrder, useOrdersStore } from '@/store/use-orders-store';
import { cn } from '@/utils/cn';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';

type Props = {
  orderId: string;
};

export default function SettledFunding({ orderId }: Props) {
  const address = useAccountStore((state) => state.address);
  const settledFunding = useOrdersStore(
    (state) =>
      (state.getOrders(address).orders[orderId] as FilledOrder).settledFunding,
  );
  return (
    <span
      className={cn('text-vestgrey-100', {
        'text-red': settledFunding < 0n,
        'text-green': settledFunding > 0n,
      })}
    >
      {formatBigInt(settledFunding, COLLATERAL_DECIMALS, {
        digits: 2,
        showChange: true,
      })}
    </span>
  );
}

export const settledFundingAccessorFn = (id: string) => {
  const { address } = useAccountStore.getState();
  const { settledFunding } = useOrdersStore.getState().getOrders(address)
    .orders[id] as FilledOrder;

  const fundingNum = bigIntToNum(settledFunding, COLLATERAL_DECIMALS);

  return Number.isNaN(fundingNum) ? undefined : fundingNum;
};
